


































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import DraftCard from '@/components/cards/DraftCard.vue';
import SubjectCard from '@/components/cards/SubjectCard.vue';
import ZeroStateCallToAction from '@/components/ZeroStateCallToAction.vue';
import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';

export default Vue.extend({
  components: {
    DraftCard,
    SubjectCard,
    ZeroStateCallToAction,
  },
  computed: {
    ...mapGetters({
      drafts: 'drafts',
      highlightedSubjects: 'highlightedSubjects',
    }),
    mostAdvancedDraft(): EssayReplyModel {
      return this.drafts
        .concat()
        .sort(
          (A: EssayReplyModel, B: EssayReplyModel) =>
            B.completed() - A.completed(),
        )[0];
    },
  },
  created() {
    this.$store.dispatch('PULL_DRAFTS');
  },
});
